import React, { useState } from "react";
import { FiEye } from "react-icons/fi";

const KPIRatingTable = ({ commentsData }) => {
  const [showTable, setShowTable] = useState(false);

  return (
    <div className="w-full max-w-2xl mx-auto mt-10 text-center">
      <button
        onClick={() => setShowTable(!showTable)}
        className="
          inline-flex items-center gap-2
          px-6 py-3
          rounded-full
          bg-gradient-to-r from-[#1A2B5C] via-[#EE1D23] to-[#1A2B5C]
          text-white font-bold
          shadow-xl
          transform hover:scale-105 hover:brightness-110
          transition-all duration-500
          animate-gradient
          bg-[length:200%_200%]
        "
      >
        <FiEye className="text-xl" />
        {showTable ? "Hide Comments" : "View Your Comments"}
      </button>

      {showTable && commentsData && commentsData.comments && (
        <div
          className="
            relative
            overflow-hidden
            rounded-3xl
            border border-white/10
            shadow-[0_20px_60px_rgba(0,0,0,0.3)]
            mt-10
            bg-white/10
            backdrop-blur-2xl
            bg-clip-padding
            p-1
            animate-fade-in
            transform hover:scale-[1.02] hover:rotate-[-0.3deg]
            transition-all duration-500
          "
        >
          {/* Top badge bar */}
          <div className="absolute top-0 left-0 right-0 h-3 bg-gradient-to-r from-[#EE1D23] via-[#1A2B5C] to-[#808080] rounded-t-3xl animate-pulse"></div>

          <table className="min-w-full text-lg text-center rounded-3xl overflow-hidden backdrop-blur-lg">
            <thead className="bg-gradient-to-r from-[#1A2B5C] via-[#EE1D23] to-[#1A2B5C] text-white shadow-lg">
              <tr>
                <th className="px-10 py-6 border-b border-white/20 tracking-wide text-xl">Comments</th>
                <th className="px-10 py-6 border-b border-white/20 tracking-wide text-xl">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                className="
                  group
                  hover:bg-white/10
                  hover:backdrop-blur-2xl
                  transition-all duration-700
                  rounded-xl
                  cursor-pointer
                  relative
                "
              >
                <td className="px-10 py-10 border-b border-white/10 font-medium text-gray-900 relative">
                  <span
                    className="
                      bg-gradient-to-r from-[#1A2B5C] via-[#EE1D23] to-[#1A2B5C]
                      bg-[length:300%_300%]
                      bg-clip-text text-transparent
                      group-hover:underline group-hover:decoration-[#EE1D23] group-hover:decoration-4
                      transition-all duration-700
                      animate-gradientText
                    "
                  >
                    {commentsData.comments}
                  </span>
                </td>
                <td
                  className={`px-10 py-10 border-b border-white/10 font-bold ${
                    commentsData.empStatus === "Agree"
                      ? "text-green-700"
                      : commentsData.empStatus === "Disagree"
                      ? "text-red-700"
                      : "text-gray-700"
                  }`}
                >
                  {commentsData.empStatus}
                </td>
              </tr>
            </tbody>
          </table>

          {/* Animated glowing border */}
          <div className="absolute inset-0 rounded-3xl border-2 border-transparent animate-neon-glow"></div>
        </div>
      )}

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in {
            animation: fadeIn 0.8s ease-out forwards;
          }
          @keyframes neonGlow {
            0%, 100% {
              border-color: rgba(238, 29, 35, 0.4);
            }
            50% {
              border-color: rgba(26, 43, 92, 0.6);
            }
          }
          .animate-neon-glow {
            animation: neonGlow 5s ease-in-out infinite;
          }
          @keyframes gradientShift {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .animate-gradient {
            animation: gradientShift 6s ease infinite;
          }
          .animate-gradientText {
            animation: gradientShift 8s ease infinite;
          }
        `}
      </style>
    </div>
  );
};

export default KPIRatingTable;
